<template>
  <div style="font-family: 'VzNHGeDS-reg11'" class="dashboard">
    <!-- <div id="vz-gh20"></div> -->
    <!-- <div id="resultDiv"></div> -->
    <div class="header">
      <div class="pull-left">
        <a href="/">
          <img
            src="data:image/png;base64,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"
        /></a>

        <br />
        <div style="height: 20px">&nbsp;</div>
        Health check Dashboard for VBG Environment
        <div style="height: 15px">&nbsp;</div>
      </div>
      <div>
        <button type="button" class="refresh_btn" @click="refreshPage()">
          <span class="reload" :class="getRefresh ? 'rotating-icon' : ''"
            >&#x21bb;</span
          >
          Refresh
        </button>
      </div>
    </div>
    <main>
      <VbgTabs />

      <VbgTab
        v-for="tab in getTotalVzAuth"
        :key="tab.tabName"
        :name="tab.tabName"
      >
        <component
          :is="tab.componentName"
          :tab="tab"
          :key="refresh"
        ></component>
      </VbgTab>
    </main>

    <!-- <div id="vz-gf20"></div> -->
  </div>
</template>
    
<script>
// import $ from "jquery";
import { mapActions, mapGetters } from "vuex";
// import ClearWhite from "@/common/assets/styles/corp/images/clear_white.png";
// import CustomLoaderComponent from "@/vbgauth/components/CustomLoaderComponent.vue";
import commonMixin from "@/common/mixin/commonMixins";
import VbgBuildInfoCard from "./VbgBuildInfoCard.vue";
import VbgTabs from "./VbgTabs.vue";
import VbgTab from "./VbgTab.vue";
import VbgHealthCheck from "./VbgHealthCheck.vue";
import VbgQuickLinks from "./VbgQuickLinks.vue";
export default {
  name: "VbgDashboardRoot",
  components: {
    VbgBuildInfoCard,
    VbgTabs,
    VbgTab,
    VbgQuickLinks,
    VbgHealthCheck,
  },
  mixins: [commonMixin],
  data() {
    return {
      amsevqa1: [
        {
          name: "AM Server QA1",
          // url: "https://mbaccmgrqa1.sdc.vzwcorp.com/vzauth/keepAlive.jsp",
          url: "https://mbaccmgrqa4.sdc.vzwcorp.com/qa1buildinfo/vzauth/keepAlive.jsp",
          // url: "https://mbaccmgrqa1.sdc.vzwcorp.com/vzauth/buildinfo",
          flag: false,
        },
      ],
      igqa1: [
        {
          name: "IG Server QA1",
          url: "https://mbaccmgrqa4.sdc.vzwcorp.com/qa1buildinfo/ig/status.html",
          // url: "https://mbaccmgrqa1.sdc.vzwcorp.com/ig/status.html",
          flag: false,
        },
      ],
      iamqa1: [
        {
          name: "IAM Server QA1",
          url: "https://mbaccmgrqa4.sdc.vzwcorp.com/qa1buildinfo/ifgservices/vbg/aaservices/healthcheck",
          // url: "https://mbaccmgrqa1.sdc.vzwcorp.com/ifgservices/vbg/aaservices/healthcheck",

          flag: false,
        },
      ],
      adaptiveAuthqa1: [
        {
          name: "Adaptive Auth QA1",
          url: "https://mbaccmgrqa4.sdc.vzwcorp.com/qa1buildinfo/ifgservices/vbg/aaservices/buildinfo",
          flag: false,
        },
      ],
      amsevqa2: [
        {
          name: "AM Server QA2",
          // url: "https://mbaccmgrqa2.sdc.vzwcorp.com/vzauth/keepAlive.jsp",
          url: "https://mbaccmgrqa4.sdc.vzwcorp.com/qa2buildinfo/vzauth/keepAlive.jsp",
          flag: false,
        },
      ],
      igqa2: [
        {
          name: "IG Server QA2",
          url: "https://mbaccmgrqa4.sdc.vzwcorp.com/qa2buildinfo/ig/status.html",
          flag: false,
        },
      ],
      iamqa2: [
        {
          name: "IAM Server QA2",
          url: "https://mbaccmgrqa4.sdc.vzwcorp.com/qa2buildinfo/ifgservices/vbg/aaservices/healthcheck",
          flag: false,
        },
      ],
      adaptiveAuthqa2: [
        {
          name: "Adaptive Auth QA2",
          url: "https://mbaccmgrqa4.sdc.vzwcorp.com/qa2buildinfo/ifgservices/vbg/aaservices/buildinfo",
          flag: false,
        },
      ],
      amsevqa3: [
        {
          name: "AM Server QA3",
          url: "https://mbaccmgrqa4.sdc.vzwcorp.com/qa3buildinfo/vzauth/keepAlive.jsp",
          flag: false,
        },
      ],
      igqa3: [
        {
          name: "IG Server QA3",
          url: "https://mbaccmgrqa4.sdc.vzwcorp.com/qa3buildinfo/ig/status.html",
          flag: false,
        },
      ],
      iamqa3: [
        {
          name: "IAM Server QA3",
          url: "https://mbaccmgrqa4.sdc.vzwcorp.com/qa3buildinfo/ifgservices/vbg/aaservices/healthcheck",
          flag: false,
        },
      ],
      adaptiveAuthqa3: [
        {
          name: "Adaptive Auth QA3",
          url: "https://mbaccmgrqa4.sdc.vzwcorp.com/qa3buildinfo/ifgservices/vbg/aaservices/buildinfo",
          flag: false,
        },
      ],
      amsevqa4: [
        {
          name: "AM Server QA4",
          url: "https://mbaccmgrqa4.sdc.vzwcorp.com/qa4buildinfo/vzauth/keepAlive.jsp",
          flag: false,
        },
      ],
      igqa4: [
        {
          name: "IG Server QA4",
          url: "https://mbaccmgrqa4.sdc.vzwcorp.com/qa4buildinfo/ig/status.html",
          flag: false,
        },
      ],
      iamqa4: [
        {
          name: "IAM Server QA4",
          url: "https://mbaccmgrqa4.sdc.vzwcorp.com/qa4buildinfo/ifgservices/vbg/aaservices/healthcheck",
          flag: false,
        },
      ],
      adaptiveAuthqa4: [
        {
          name: "Adaptive Auth QA4",
          url: "https://mbaccmgrqa4.sdc.vzwcorp.com/qa4buildinfo/ifgservices/vbg/aaservices/buildinfo",
          flag: false,
        },
      ],
      amsevqa5: [
        {
          name: "AM Server QA5",
          url: "https://mbaccmgrqa4.sdc.vzwcorp.com/qa5buildinfo/vzauth/keepAlive.jsp",
          flag: false,
        },
      ],
      igqa5: [
        {
          name: "IG Server QA5",
          url: "https://mbaccmgrqa4.sdc.vzwcorp.com/qa5buildinfo/ig/status.html",
          flag: false,
        },
      ],
      iamqa5: [
        {
          name: "IAM Server QA5",
          url: "https://mbaccmgrqa4.sdc.vzwcorp.com/qa5buildinfo/ifgservices/vbg/aaservices/healthcheck",
          flag: false,
        },
      ],
      adaptiveAuthqa5: [
        {
          name: "Adaptive Auth QA5",
          url: "https://mbaccmgrqa4.sdc.vzwcorp.com/qa5buildinfo/ifgservices/vbg/aaservices/buildinfo",
          flag: false,
        },
      ],
      refresh: 1,
      vzauth: "",
      result: document.getElementById("resultDiv"),
      dropdownDiv: document.getElementById("dropDownDiv"),
      dropdownValues: document.getElementById("envDropdown"),
      envOptionDropdown: document.getElementById("envOptionDropdown"),
    };
  },
  computed: {
    ...mapGetters("dashboard", ["getTotalVzAuth", "getRefresh"]),
  },
  watch: {},
  async created() {
    const searchParams = new URLSearchParams(window.location.search);
    gnavdl = {
      bu: "smb",
      appid: "unified",
    };
  },
  mounted() {},
  methods: {
    ...mapActions("dashboard", ["pageRefresh"]),
    refreshPage() {
      this.pageRefresh();
      this.refresh += 1;
    },
  },
};
</script>
<style scoped>
body {
  padding-top: 20px;
  padding-bottom: 20px;
}
.dashboard {
  background: #f0f0f0 !important;
  height: 100vh;
  overflow: auto;
}
.header {
  background: white;
  padding: 10px 35px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  border-bottom: 1px solid #d8dada;
  margin-bottom: 10px;
}
.refresh_btn {
  margin-top: 25px;
  padding: 10px 20px;
  border: 1px solid #e51c23;
  background-color: #e51c23;
  border-radius: 3px;
  color: #ffffff;
}
.pull-left {
  color: #cd040b;
  font-size: 26px;
  font-weight: bold;
  margin-top: 10px;
}
.rotating-icon {
  display: inline-block;
  animation: rotate 2s linear infinite;
}
.reload {
  margin-right: 5px;
  font-size: 20px;
  font-family: Lucida Sans Unicode;
}

@keyframes rotate {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
@media only screen and (max-width: 768px) {
  /* For Tabs: */
  /* .main-container {
    grid-template-columns: repeat(2, 1fr) !important;
    padding: 7px 12px;
  } */
}
@media only screen and (max-width: 600px) {
  /* For mobile phones: */
  /* .main-container {
    grid-template-columns: 1fr !important;
    padding: 10px 0px;
  } */
  .header {
    display: block;
    padding: 25px 18px;
  }
  .pull-left {
    margin-top: 0px;
  }
  .refresh_btn {
    margin: 0;
  }
}
</style>
